import { Pipe, PipeTransform, inject } from '@angular/core';

import { AppConfig } from '@app/app.config';
import { ShortPipe } from '@shared/pipes/short.pipe';

const DEFAULT_IMPRESSION_THRESHOLD_VALUE = 5000;

@Pipe({
    name: 'impression',
})
export class ImpressionPipe implements PipeTransform {
    private readonly shortPipe = inject(ShortPipe);
    private readonly appConfig = inject(AppConfig);

    transform(impressionValue: number, shortValuePrecision = 1, roundSmall?: boolean, naStr?: string): string {
        if (impressionValue == null) {
            return naStr ?? 'N/A';
        }

        const returnValue = this.shortPipe.transform(impressionValue, shortValuePrecision, roundSmall, naStr);

        if (+returnValue === 0) {
            return returnValue;
        }

        let impressionThresholdValue = this.appConfig.settings?.settings?.impression_threshold_value as number;

        if (impressionThresholdValue == null) {
            impressionThresholdValue = DEFAULT_IMPRESSION_THRESHOLD_VALUE;
        }

        if (impressionThresholdValue > impressionValue) {
            return `<${this.shortPipe.transform(impressionThresholdValue, shortValuePrecision, roundSmall, naStr)}`;
        }

        return returnValue;
    }
}
